<template>
    <div>
        
             <ob-spinner v-if="loadSpinner"></ob-spinner> 
            <div class="notes" v-else>
                <div class="notes-content"  v-if="!noNotes && noteDetails.length > 0">
                    <div class="note-details" v-for="(n, index) in noteDetails" :key="index">
                        <p v-html="n.NotesName"></p>
                        <span>Posted By {{n.CreatedBy.FirstName}} {{n.CreatedBy.LastName}}</span>
                        <span>{{n.ModifiedDateTime | formatDate('MM/DD/YYYY hh:mm a')}}</span>
                        <!-- Controls -->
                        <!-- <div style="display: inline-block;" v-if="n.CreatedBy.Id == loggedInUserObj.empId">
                            <select class="native-select" v-model="n.IsPublic" @change="typeChangeClick(n)" :disabled="editMode || isLoading || hasRestriction">
                                <option value="false">Private</option>
                                <option value="true">Public</option>
                            </select>
                            <ob-button type="link" @click="updateNotes(n)" :disabled="editMode || isLoading || hasRestriction">Edit</ob-button>
                            <ob-button type="link" @click="deleteNotes(n)" :disabled="editMode || isLoading || hasRestriction">Delete</ob-button>
                        </div> -->
                    </div>
                </div>
                <div v-else  style="height: 400px;display:table;width:100%;">
                        <div class="pfa-body" style="display: table-cell; vertical-align: middle;text-align: center;">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/Folder_icon.svg`" style="margin-bottom:20px;" /> 
                            <h5 class="pfa-info_msg">
                                No Notes
                            </h5>
                        </div>
                </div>
                <!-- <div class="note-footer">
                    <text-area-mentions :disable="disableTextArea || hasRestriction" @textarea-content="getTextAreaContent" @onsearch="v => searchUserList = v"></text-area-mentions>
                    <textarea id="content" placeholder="Compose a note..." v-model="textareaContent" :disabled="isLoading" ></textarea>
                    <template v-if="loggedInUserObj.SubscriptionType == 'Free'">
                        <span  v-tooltip="'Please subscribe to add notes'"><ob-button type="primary" @click="postNotesDetail" :disabled="true" >{{buttonText}}</ob-button></span>
                    </template>
                    <template v-else>
                        <ob-button type="primary" @click="postNotesDetail" :disabled="textareaContent.trim() == '' || isLoading">{{buttonText}}</ob-button>
                    </template> 
                    <ob-button type="secondary" @click="postNoteCancel" :disabled="isLoading" v-show="editMode">Cancel</ob-button>
                </div> -->
            </div>

    </div>

</template>

<script>
    import jquery from "jquery"
    import TextAreaMentions from "@/components/ESSProfile/ESSComponents/TextAreaMentions.vue"
export default {
    //props: ["id", "isOnBlick", "consultantDetails"],
    data() {
        return {
            isLoading: false,
            editMode: false,
            textareaContent: '',
            notes:'',
            noteId: '',
            notePublic: false,// added for Is Public flag while editing the notes
            originalNoteDetails: [],
            NotesData: {
                ConsultantId: null,
                NoteId: null,
                IsOnBlick: null
            },
            searchUserList: [],
            EmailLocalArr:'',
            mentionsCollection:'',
            hasRestriction:false,
            // props val 
            //id: '5bb1d9ef25f57f0eb808ef1f',
            isOnBlick: true,
            consultantDetails: {

            },            
            noNotes : false,
            loadSpinner:true,
          }    
    },
    components:{
        "text-area-mentions":TextAreaMentions
    },
    computed: {
        noteDetails() {
            if (this.originalNoteDetails) {
                return this.originalNoteDetails.filter((n) => {
                    return n.IsPublic == true || n.IsPublic == false || n.CreatedBy.Id == this.loggedInUserObj.Id || (n.Emails && n.Emails.indexOf(this.loggedInUserObj.Email) !== -1)
                })

            } else {
                return []
            }
        },
        loggedInUserObj() {
            // let tempData = {
            //     Email:"rajeev@rigaps.com",
            //     Id:"5b39e776d864c31198481237",
            //     Name:"Rajeev Ranjan",
            //     OrgAddress:"Royal Lanes",
            //     OrgId:"5b03d5ce2e3c600b88f30104",
            //     OrgLogoLink:"https://onblickdevstorage.blob.core.windows.net/rigcontainer/5b03d5ce2e3c600b88f30104obk.png",
            //     OrgName:"DOTS TECHNOLOGIES INC",
            //     OrgWebSite:"https://www.google.com",
            //     Role:"HRManager",
            //     Roles:Object,
            //     SubscriptionType:"Active",   
            // }
            // return tempData
            return this.loggedInUserObj
        },
        buttonText() {
            if(this.editMode) {
                return 'Update'
            } else {
                return 'Add'
            }
        },
        textareaWithBR() {
            // prevent XSS attack
            // sanitizing script tags
            return this.textareaContent.replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\n/gi, "<br>")
        },
        disableTextArea(){
            if(this.isLoading == true)
                return true
            else
                return false
        },
        EmailArr(){
            if(this.EmailLocalArr != ''){
                let emailArray = []
                this.EmailLocalArr.forEach((e)=>{
                    var params={
                        Id:e.id,
                        FirstName:e.firstname,
                        LastName:e.lastname,
                        Name:e.value,
                        Email:e.email
                    }
                    emailArray.push(params)
                })
                return emailArray
            }
            else 
                return []
         },
         getSelectedCollections(){
            if(this.mentionsCollection != ''){
                var getCollection = []
                this.mentionsCollection.forEach((m)=>{
                    this.searchUserList.forEach((c)=>{
                        if(c.uid == m.uid){
                            getCollection.push(c)
                        }
                    })
                })
                return getCollection
            }
            else
                return []
        },
        /* loadSpinner(){
             if(this.noteDetails != null)
                 return false
             else 
                 return true
         }*/
    },
    watch:{
        noteDetails(val){
            if(val != null){
                if(val.length > 0){
                    val.forEach((n)=>{
                        let name = n.Name,
                        regex = /([.*+?^=!:${}()|\[\]\/\\])/g;
                        if(regex.test(name) ==  true){
                            let nameNew = name.replace(/@\[([^\[]*)\]\((contact:[^\)]*)\)/gi, "<span class='ob-mention-highlighted'>@$1</span>");
                            this.$set(n,'NotesName',nameNew)
                        }
                        else
                            this.$set(n,'NotesName',name)
                    })
                }
            }           
        }
    },
    created() {
        this.fetchnoteDetails()
        
    },
    methods:{
        
        //select contact from list
        /*typeChangeClick(c) {
            this.isLoading = true
           let NotesDetailsJson = {
                "ConsultantId": "",
                "NoteId": "",
                "Notes": "",
                "Emails": [
                 
                    ],
                "IsPublic": null,
                "IsOnBlick": null
           }        
                NotesDetailsJson.ConsultantId = this.id
                NotesDetailsJson.NoteId = c.Id
                NotesDetailsJson.Notes = c.Name
                NotesDetailsJson.Emails = c.Emails
                NotesDetailsJson.IsOnBlick = this.isOnBlick
                NotesDetailsJson.IsPublic = c.IsPublic
                ajax.post(`/MyDatabase/AddOrUpdateConsultantNotes`,NotesDetailsJson,(res)=> {
                        if(res.data.State == true) {
                            // empty fields
                            this.textareaContent='';
                            this.noteId='';
                            this.EmailArr = []
                            this.fetchnoteDetails();
                        }
                });
        },*/
        /*updateNotes(n){
            this.editMode = true
            this.textareaContent = n.Name.replace(/<br>/gi, "\n")
            events.fire('notes-edited',this.textareaContent)
            this.noteId = n.Id
            this.notePublic = n.IsPublic
        },
        deleteNotes(n){
            this.NotesData.ConsultantId = this.id;
            this.NotesData.NoteId = n.Id;
            this.NotesData.IsOnBlick = this.isOnBlick;
            this.deleteNotesDetails();
        },*/
        fetchnoteDetails() {
            
            ajax.get(`/MyDatabase/GetConsultantNotes?consultantId=${loggedInUserObj.consultantId}&isOnblick=${this.isOnBlick}&orgId=${loggedInUserObj.orgId}`, {}, (res) => {
                
                /*if(res.data.HasRestriction == true){
                   
                    this.hasRestriction = true
                }*/
                if(res.data.State == true){
                     this.noNotes = false
                    this.originalNoteDetails = res.data.Notes
                    this.loadSpinner = false
                }else{
                    this.loadSpinner = false
                    this.ESSEnableDisable(res) 
                    this.noNotes = true
                }

            })
        },
     /*  postNotesDetail() {
           this.isLoading = true
           let NotesDetailsJson = {
               "ConsultantId": "",
               "NoteId": "",
               "Notes": "",
               "Emails": [
                 
                    ],
               "IsPublic": false,
               "IsOnBlick": null
                    }
           NotesDetailsJson.ConsultantId = this.id
           NotesDetailsJson.NoteId = this.noteId
           NotesDetailsJson.Notes = this.textareaWithBR
           NotesDetailsJson.Emails = this.EmailArr
           NotesDetailsJson.IsOnBlick = this.isOnBlick
           NotesDetailsJson.IsPublic = this.notePublic
           
           ajax.post(`/MyDatabase/AddOrUpdateConsultantNotes`,NotesDetailsJson,(res)=> {
               if(res.data.State == true) {
                   // empty fields
                   this.textareaContent='';
                   this.noteId='';
                   events.fire('added-notes')
                   if(this.editMode)
                    this.editMode = false

                   this.isLoading = false

                   this.notePublic = false

                   this.fetchnoteDetails();
                }
           });
        },
        postNoteCancel(){
            // empty fields
            this.textareaContent=''
            this.noteId=''
            this.EmailLocalArr =''
            events.fire('added-notes')
            this.editMode = false
            this.notePublic = false
        },
        deleteNotesDetails() {

            this.isLoading = true
             ajax.put('/MyDatabase/RemoveConsulantNotes', this.NotesData, (res) => {
                if(res.data.State == true) {
                    //empty fields
                    this.NoteData = '';
                    
                    this.isLoading = false

                    this.fetchnoteDetails();
                }
           });
        },*/
       /* getTextAreaContent(params){
            this.textareaContent = params.value
            this.mentionsCollection = params.collection
            this.EmailLocalArr = this.getSelectedCollections
        },*/
    }
}
</script>

<style lang="scss" scoped>

 @import "~styles/framework/vue-utils";


    .vue-my-database-page {

        @import "~styles/pages/vue/my-database/components/profile";
    }

    .contacts-list-box {
        position: absolute;
        bottom: 130px;
        display: inline-block;
        padding: 10px;
        border: 1px solid #ddd;
        max-height: 300px;
        overflow: auto;
        width: 300px;
        background: #fff;
    .contact-inner

    {
        width: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover

    {
        background: #ddd;
    }

    }

    .contact-name-mail {
        display: inline-block;
        width: calc(100% - 50px);
        h3,span

    {
        display: inline-block;
        width: 225px;
        padding: 0 0 0 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0px;
        font-size: 12px;
    }

    h3 {
        color: $ob-brand-primary;
        font-weight: 600;
    }

    span {
        color: #333;
    }

    }
    }

    .native-select {
        border: none;
        color: #4A90E2;
        cursor: pointer;
    }

        .native-select[disabled] {
            color: #999;
            cursor: not-allowed;
            opacity: 0.65;
        }

    select.native-select option {
        border: none;
    }
    textarea{
         height: 60px !important;
    }
span.ob-mention-highlighted{
    background:#f4f4f4;
    font-weight:bold;
    color:#106ebe;
    padding:0 5px 0 0!important;
}


    .pfa-body {
        padding: 15px;
        display: inline-block;
        .pfa-info_msg {
                color: $ob-brand-primary;
                font-size: 13px;
                line-height: 20px;
                margin: 0;
        }

    }    
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/EmpNotes.vue